<div
  [class]="{ 'alert-danger': type === 'danger', 'alert-warning': type === 'warning', 'alert-info': type === 'info' }"
>
  <div class="headline">
    <ng-content select="[mpAlertIcon]" />
    <ng-content select="[mpAlertTitle]" />
  </div>
  <ng-content />
</div>
